export default class BasePage {
  constructor(info) {
    this.key = info.key;
    this.ele = info.ele;
    this.motionType = info.motionType;
    this.showBaseMotion = new TimelineMax({paused: true, onComplete: this._showBaseComplete, onCompleteParams: [this]});
  }

  show(size, dx) {
    let startPos = {x:0, y:0}
    if(size){
      if(this.motionType == 'vertical'){
        startPos.y = size.height * dx;
      }else if(this.motionType == 'horizontal'){
        startPos.x = size.width * dx;
      }
    }
    TweenLite.set(this.ele, {css:{className:'+=show'}});
    TweenLite.fromTo(this.ele, 0.7, startPos, {x:0, y:0, ease:Cubic.easeOut, onComplete: this._showBaseComplete, onCompleteParams: [this]});
  }

  _showBaseComplete(thisv) {
    thisv.ele.dispatchEvent(new CustomEvent("pageEvent", {detail: {action: 'showComplete', key: thisv.key}}));
  }
  hide(size, dx, moveSec){
    let endPos = {x:0, y:0, onComplete: this._hidetComplete, onCompleteParams: [this]}
    if(size){
      if(this.motionType == 'vertical'){
        endPos.y = size.height * dx;
      }else if(this.motionType == 'horizontal'){
        endPos.x = size.width * dx;
      }
    }
   // if(!moveSec)TweenLite.set(this.ele, {css:{className:'-=show'}});
    TweenLite.set(this.ele, {css:{className:'-=show'}});
    TweenLite.set(this.ele, {css:{className:'+=hide'}});
    TweenLite.fromTo(this.ele, 0.7, {x:0, y:0}, endPos);
  }

  _hidetComplete(thisv) {
    TweenLite.set(thisv.ele, {css:{className:'-=hide'}});
  }
}



// WEBPACK FOOTER //
// ./src/js/page/basePage.js